import React, { useState } from "react";
import {
  Typography,
  IconButton,
  Card,
  CardContent,
  Popover,
  Button,
} from "@material-ui/core";
import { AccountCircle as UserIcon } from "@material-ui/icons";

import { logout, getEmailLogged } from "../../../Store/Actions/API/authActions";
import { SessaoUsuario } from "../../../Utils/token";
import { useStyles } from "./styles";

function Usuario() {
  const classes = useStyles();
  const [userLoger] = useState(getEmailLogged());
  const [anchorEl, setAnchorEl] = useState(null);
  const isAdmin = SessaoUsuario("isAdmin");

  function openLink(link) {
    window.open(link, "_self");
  }

  return (
    <>
      <IconButton
        aria-controls="usuario"
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <UserIcon className={classes.icons} fontSize="large" />
      </IconButton>
      <Popover
        id="usuario"
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Card>
          <CardContent>
            <div className={classes.user}>
              <UserIcon className={classes.userIcon} />
              <div className={classes.infoUsuario}>
                <Typography className={classes.email}>{userLoger}</Typography>
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={() =>
                    openLink("https://conta.e-auditoria.com.br/Perfil")
                  }
                >
                  Minha conta
                </Button>
              </div>
            </div>

            <div className={classes.actions}>
              {isAdmin ? (
                <Button
                  variant="outlined"
                  onClick={() =>
                    openLink("https://conta.e-auditoria.com.br/Faturamento")
                  }
                >
                  Faturamento
                </Button>
              ) : (
                <div />
              )}
              <Button variant="outlined" onClick={logout}>
                Sair
              </Button>
            </div>
          </CardContent>
        </Card>
      </Popover>
    </>
  );
}

export default Usuario;
